import { api } from "./index";

export function createClaim(data) {
  return api.post("/claim", data);
}
